import React from "react";
import { SvgIcon } from "@material-ui/core";

const NetworkIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 60 60">
      <path
        id="Path_4184"
        data-name="Path 4184"
        d="M37,0a5.915,5.915,0,0,1,3.2.571c1.015.624,5.8,5.325,6.049,6.4.55,2.4-3.322,3.559-1.141,6.853,2.8,4.226,5.664-.64,7.875-.114,1.4.332,6.64,5.959,6.962,7.538.731,3.59-4.785,7.416-6.505,9.137l-22.6,22.614c-1.849,1.85-6.146,8.046-10.043,6.853-1.306-.4-6.79-5.609-7.076-6.853-.589-2.566,3.562-3.753.8-7.2-2.841-3.539-5.152,1.022-7.532.457-1.249-.3-6.449-5.767-6.847-7.081-1.157-3.812,5.653-9.193,7.646-10.85l5.478-5.711L27.982,8.107C31.013,5.3,33.165,2.051,37,0Zm.685,4.34L4.357,37.8v.228l3.424,3.2A8.194,8.194,0,0,1,19.65,47.054c.412,2.059-1.137,4.526-.685,5.368l3.082,3.2h.228L55.6,22.155v-.228l-3.31-3.2c-7.1,3.388-15.244-3.567-11.07-10.965C40.522,6.732,38.918,4.745,37.682,4.338ZM31.976,16.673c2.955-.011,7.526,6.047,9.358,7.881.743.743,2.422,1.559,1.94,3.426-.369,1.43-7.863,8.1-9.358,9.594-1.119,1.12-5.112,6.247-7.19,5.711-1.586-.409-3.237-3.011-4.337-4.112-1.183-1.184-5.339-4.479-5.706-5.939-.563-2.237,2.24-3.727,3.2-4.683C23.73,24.7,27.444,19.75,31.976,16.673Zm.571,5.14L21.819,32.549l5.478,5.6L38.139,27.409l-5.478-5.6Z"
        transform="translate(-0.003 0.003)"
        fillRule="evenodd"
      />
    </SvgIcon>
  );
};

export default NetworkIcon;
